// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"296":"af523f921637a439","5279":"3a9dc4240b221a65","7229":"554f4e11cdd0f29c","9464":"3cca94a6fee9c261"}[chunkId] + ".js";
};